export function Impacto() {
  const stats = [
    { number: '15', label: 'Comunidades atendidas' },
    { number: '200', label: 'Artistas remunerados' },
    { number: '50', label: 'Projetos executados' },
    { number: '100k', label: 'Pessoas impactadas' }
  ];

  return (
    <section className="py-40 px-8 lg:px-20 bg-gradient-to-r from-dark via-dark-light to-dark relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03]">
        <div className="flex gap-8 justify-center items-center h-full">
          {[1, 2, 3, 4, 5].map((i) => (
            <i key={i} className="ri-ancient-gate-line text-gold text-[200px]"></i>
          ))}
        </div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center mb-20">
          <h2 className="font-display text-5xl lg:text-6xl font-bold text-white mb-6">
            Impacto em Números
          </h2>
          <p className="text-xl text-gold font-medium italic">
            Cultura é infraestrutura social.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center relative">
              <div className="space-y-4">
                <div className="text-8xl lg:text-9xl font-display font-extralight text-gold">
                  {stat.number}
                  <span className="text-5xl align-super">+</span>
                </div>
                <p className="text-xs uppercase tracking-[0.3em] text-gray-400 font-semibold">
                  {stat.label}
                </p>
              </div>
              
              {index < stats.length - 1 && (
                <div className="hidden lg:block absolute right-0 top-1/2 -translate-y-1/2 w-px h-20 bg-gold/30"></div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-20 text-center space-y-6">
          <div className="space-y-4">
            <h3 className="text-2xl font-display font-semibold text-white">
              Captação & Parcerias
            </h3>
            <p className="text-gray-400 max-w-3xl mx-auto leading-relaxed">
              A Mansa Musa JH atua com Lei Rouanet, ProAC, incentivos municipais, emendas parlamentares e patrocínio privado.
            </p>
            <p className="text-white text-lg font-medium max-w-3xl mx-auto leading-relaxed">
              Estruturamos projetos aptos a receber investimento com segurança jurídica, clareza técnica e impacto mensurável.
            </p>
          </div>

          <div className="pt-8 space-y-4">
            <h3 className="text-2xl font-display font-semibold text-white">
              Transparência
            </h3>
            <p className="text-gray-400 max-w-2xl mx-auto leading-relaxed">
              Empresa cultural ativa e regularizada. CNPJ ativo, natureza cultural, gestão responsável e prestação de contas conforme legislação.
            </p>
            <p className="text-gold text-lg font-medium italic">
              Transparência é base da prosperidade sustentável.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
